import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Button from 'components/Button/Button';
import FormContainer from 'components/LoanForm/FormContainer';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { getLoanOffer } from 'selectors/getLoanOfferData';
import { getApplicationData as selectApplicationData } from 'selectors/getApplicationData';
import { FlowComponentType } from 'routes/types';
import useLoanOfferProcessor from 'hooks/useLoanOfferProcessor';
import { updateLoanOffer } from 'thunks';
import { ApplyingResult } from 'enums/FlowNextResults';
import UserSessionWarning from 'components/Common/UserSessionWarning/UserSessionWarning';

import styles from './BureauVerification.module.scss';

const BureauVerification = ({ handleNext }: FlowComponentType): JSX.Element => {
  const [rerunFailed, setRerunFailed] = useState(false);

  const { isLoading } = useSelector(getLoanOffer);
  const { application } = useSelector(selectApplicationData);

  const { processLoanOffer } = useLoanOfferProcessor({
    handleNext,
  });

  const dispatchWithUnwrap = useDispatchWithUnwrap();

  const handleContinue = async () => {
    setRerunFailed(false);

    const runLoanOffer = () => dispatchWithUnwrap(updateLoanOffer({ applicationId: application!.id }));

    const res = await processLoanOffer(runLoanOffer);

    if (!res || res.data.credit_passed) {
      handleNext(ApplyingResult.Done);
    } else {
      setRerunFailed(true);
    }
  };

  return (
    <FormContainer
      title="Additional verification required"
      subtitle="The bureau requires additional verification before moving forward. You will get a text message with a link to verify your identity. Please click that link and once confirmed come back to this page to continue with the application."
      className={styles.container}
    >
      {rerunFailed && (
        <UserSessionWarning
          message="We haven't confirmed your identity verification yet. Please check your texts, complete the link, and try again."
          showContactUsOption
        />
      )}
      <Button className={styles.primaryButton} isLoading={isLoading} onClick={handleContinue}>
        Continue application
      </Button>
    </FormContainer>
  );
};

export default BureauVerification;
